<template>
    <div class="contr">
        <fixed-header>
            <div class="navbar">
                <mobileNav class="mob">

                </mobileNav>

                <nav class="nav">
                    <div class="logo"><router-link to="/"><img src="../assets/logo.svg" alt="" height="40"></router-link></div>
                    <div class="link-up">
                        <router-link to="/about" >About</router-link>
                        <router-link to="/faq" href="">FAQs</router-link>
                        <a href="">Stories</a>
                        <a href="">Blog</a>
                        <a href="" style="color: #622586">Sign In</a>
                        <router-link to="" class="nav-button">Create Free Account</router-link>
                    </div>
                </nav>
            </div>
        </fixed-header>

        <div class="faq">
            <h1>Frequently asked questions</h1>
            <input type="text">
            <div class="fq-flex">
                <div class="fq-box">
                    <img src="../assets/started icon.svg">
                    <p>Getting Started</p>
                </div>
                <div class="fq-box">
                    <img src="../assets/invest-icon.svg" style="width: 1rem">
                    <p>Investing</p>
                </div>
                <div class="fq-box">
                    <img src="../assets/security-icon.svg">
                    <p>Safety &amp; Security</p>
                </div>
            </div>
        </div>
        <div class="jumbo">
        <div class="faq-block" v-on:click="helper()">
            <div class="left"><h2 style="display: block;">Getting Started</h2></div>
            <div class="faq-holder">
                <details>
                    <summary>What is i-invest</summary>
                    <p>
                        i-invest is a mobile application designed to encourage people to build a savings and investment culture.
                        It provides a secure, fast and convenient way for the average man to access investment products
                        otherwise reserved for the elite.
                    </p>
                </details>
                <details>
                    <summary>What do I need to register?</summary>
                    <p>
                        i-invest is a mobile application designed to encourage people to build a savings and investment culture.
                        It provides a secure, fast and convenient way for the average man to access investment products
                        otherwise reserved for the elite.
                    </p>
                </details>
            </div>
        </div>
        <footer1></footer1>
            <footer2></footer2>
        </div>
    </div>
</template>

<script>
    import footer1 from '../components/home/footer1.vue'
    import footer2 from '../components/home/footer2.vue'
    import help from '../alternate'
    import FixedHeader from 'vue-fixed-header'
    import mobileNav from '../components/mobile-nav.vue'
    export default {
        name: 'faq',
        components: {
            footer1,
            footer2,
            FixedHeader,
            mobileNav
        },
        data() {
            return{
                isOpen: true,
                myHelp : help
            }
        },
        methods: {
            toggleAccordion: function() {
                this.isOpen = !this.isOpen;
                if(this.isOpen === true){
                    document.querySelector('.i').innerHTML="-"
                }else{
                    document.querySelector('.i').innerHTML="+"
                }

            },

            helper : function () {
                const details = document.querySelectorAll("details");

                details.forEach((targetDetail) => {
                    targetDetail.addEventListener("click", () => {
                        console.log('done')
                        // Close all the details that are not targetDetail.
                        details.forEach((detail) => {
                            if (detail !== targetDetail) {
                                detail.removeAttribute("open");
                            }
                        });
                    });
                });
            }
        },
        computed: {
            accordionClasses: function() {
                return {
                    'is-closed': !this.isOpen,
                    'is-primary': this.isOpen,
                    'is-dark': !this.isOpen
                };
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    *{
        color: #311342;
    }

    .navbar.vue-fixed-header--isFixed {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        filter: drop-shadow(0 5px 10px rgba(0,0,0,0.2));
        z-index: 1000;


    }

    .nav {
        display: flex;
        justify-content: space-between;
        padding: 1% 5% 1% 5%;
        background-color: #fff;
    }
    .link-up  a {
        text-decoration: none;
        padding: 0 3%;
        color: #000;
        font-weight: 600;
    }

    .nav-button {
        border: 1px solid #622586;
        padding: 1rem 2rem;
        border-radius: 3px;
        color: #622586;
        font-weight: 600;
        background-color: #fff;
        transition: all 0.5s ease-in-out;
        display: inline-block;

    }

    .nav-button:hover {
        background-color: #622586;
        color: #fff !important;
    }

    .link-up {
        width: 70%;
        text-align: right;
    }

    .jumbo {
        /*padding: 2rem 4rem;*/
    }

    .faq-block {
        padding: 4rem 5rem;
        display: flex;
    }

    .faq-block summary {
        font-weight: 700;
        font-size: 25px;
    }

    .left {
        width: 30vw;
    }
    .faq-holder {
        width: 70vw;
    }

    .faq{
        height: 50vh;
        padding-bottom: 5%;
        text-align:center;
        background-image: url('../assets/faq-bg.svg');
        background-color: whitesmoke;
        margin:0;
        margin-top: 0;
        padding-top: 5%;
        background-repeat: no-repeat;
        background-position-y: 70%;
        background-position-x: 65%;
        background-size: 140%;
    }
    .faq h1{
        margin-bottom: .8rem;
        font-size: 2.2rem;
    }
    .faq input{
        width: 40%;
        height:3rem;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 3rem;
        border-radius: 5px;
        box-shadow: 4px 6px 10px  rgba(0,0,0,0.07);
        /*filter: drop-shadow(0 5px 6px rgba(0,0,0,0.05));*/
        outline: none;
        padding: 0.1rem 1rem;
    }
    .faq input:focus {
      border: 1px solid #622586;
    }

    .fq-flex{
        display: flex;
        justify-content:center;
        /*width:45%;*/
        margin: auto;
    }
    .fq-box{
        background-color: white;
        padding:1.5rem 1rem 0.4rem 1rem;
        /*padding-top: 1.5rem;*/
        border-radius: 5px ;
        min-width: 10rem;
        min-height:6rem;
        /*box-shadow: 4px 5px 20px -14px rgba(0,0,0,0.6)*/
        box-shadow: 4px 6px 10px  rgba(0,0,0,0.07);
        margin-right: 2rem;
        /*box-sizing: border-box;*/
    }

    .fq-box:hover {
       border: 1px solid #622586;
        cursor: pointer;
    }
    .fq-box p{
        font-size: 1.2rem;
        font-weight: bold;
        margin-bottom: 0;
    }
    .fq-box img{
        width:1.5rem;
        padding-bottom: 0;
        margin-bottom: 0;
    }
    .g-blck{
        width:78%;
        margin:auto;
        display: flex;
        padding-top: 9%;

    }
    .bb1{
        font-size: 1.2rem;
        margin-right: 10%;
    }
    .message{
        border-bottom: 1px solid rgba(248, 248, 248, 0.596);
    }
    .message-header h3{
        color:#8F5EAB;
        margin-bottom: 3%;
        font-size: 1.3rem;
        flex-basis: 70%;
    }
    .message p{
        font-size: .95rem;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: 1.5px;
    }
    .message-header {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        color:#8F5EAB;
    }
    .message-header p{
        color:grey;
        font-size: 1.5rem;
    }
    .message-body   {
        padding: 0;
        max-height: 10em;
        overflow: hidden;
        transition: 0.5s ease all;
    }
    .is-closed .message-body {
        max-height: 0;
    }


    @media screen and (max-width: 500px) {
        .faq-block {
           flex-wrap: wrap;

        }
        .nav {
            display: none;
        }

        .fq-flex {
            flex-wrap: wrap;
            flex-direction: column;
            width: 50%;
        }

        .faq-block div {
            width: 100%;
        }

        .fq-box {
            margin-bottom: 0.5rem;
            margin-right: 0;
        }

        .faq {
            height: 90vh;
        }

        .faq input {
            width: 80%;
        }
        .mob {
            z-index: 1000;
        }

        .faq h1{
           padding: 0 4rem;
        }
    }


</style>